import { render, staticRenderFns } from "./CommonTableV2.vue?vue&type=template&id=4761875d"
import script from "./CommonTableV2.vue?vue&type=script&lang=js"
export * from "./CommonTableV2.vue?vue&type=script&lang=js"
import style0 from "./CommonTableV2.vue?vue&type=style&index=0&id=4761875d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports